import React, { useState } from "react";
import { toast } from "sonner";
import { CheckCircle, XCircle } from "@phosphor-icons/react";
import api from "@/lib/api";
import { errMsg } from "@/components/dashboard/BuyerRequestsCard";
import { inboxChanged } from "@/components/layout/useInboxCount";
import { ENDPOINT, noteBody } from "./inboxMeta";

const BTN = "border border-black px-3 py-1.5 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 transition-colors duration-100 disabled:opacity-40";

function approveChoices(item) {
  if (item.source === "page" && item.kind === "own_page") {
    return [[{ mode: "publish" }, "Publish now", "publish"], [{ mode: "draft" }, "Build as draft", "draft"]];
  }
  return [[item.source === "page" ? {} : noteBody(item.source, null), "Approve", "approve"]];
}

// One-click approve / turn down for any buyer request, using that request's own endpoint.
export function InboxActions({ item, onDone }) {
  const [busy, setBusy] = useState(false);
  const [rejecting, setRejecting] = useState(false);
  const [reason, setReason] = useState("");
  const p = `inbox-${item.source}-${item.id}`;
  const needsReason = item.source === "criteria";
  const act = async (action, body, ok) => {
    setBusy(true);
    try {
      await api.post(`${ENDPOINT[item.source]}/${item.id}/${action}`, body);
      const quiet = item.is_test && ["detail", "page"].includes(item.source);
      toast.success(quiet ? `${ok}. Test buyer, so no email is sent.` : `${ok}.`);
      inboxChanged();
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  if (rejecting) {
    return (
      <div className="mt-2 space-y-2">
        <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={2} maxLength={500}
                  placeholder={needsReason ? "Reason the buyer will see (needed)" : "Reason the buyer will see (optional)"}
                  className="w-full border border-black p-2 text-xs" data-testid={`${p}-reason`} />
        <div className="flex flex-wrap gap-2">
          <button type="button" disabled={busy || (needsReason && !reason.trim())}
                  onClick={() => act("reject", noteBody(item.source, reason.trim() || null), "Turned down")}
                  className={`${BTN} bg-rose-600 text-white`} data-testid={`${p}-reject-confirm`}>
            <XCircle size={12} weight="bold" /> Turn down
          </button>
          <button type="button" onClick={() => setRejecting(false)} className={`${BTN} hover:bg-black hover:text-white`} data-testid={`${p}-reject-cancel`}>Cancel</button>
        </div>
      </div>
    );
  }
  const blocked = item.type === "rules" && !item.changes?.length;
  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {approveChoices(item).map(([body, label, key]) => (
        <button key={key} type="button" disabled={busy || blocked} onClick={() => act("approve", body, `${label === "Approve" ? "Approved" : label} done`)}
                className={`${BTN} bg-emerald-700 text-white hover:bg-emerald-800`} data-testid={`${p}-${key}`}>
          <CheckCircle size={12} weight="bold" /> {busy ? "Working…" : label}
        </button>
      ))}
      <button type="button" disabled={busy} onClick={() => setRejecting(true)} className={`${BTN} hover:bg-black hover:text-white`} data-testid={`${p}-reject`}>
        <XCircle size={12} weight="bold" /> Turn down
      </button>
    </div>
  );
}
